module.exports = __webpack_public_path__ + "static/media/Skalky_Havraniky.76ed536e.md";